import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
interface TickerItem {
  label: string;
  price: string;
  change: string;
  isNegative: boolean;
}
const tickerData: TickerItem[] = [{
  label: 'CHOICE CUTOUT',
  price: '$388.37',
  change: '+2.18',
  isNegative: false
}, {
  label: 'CHOICE-SELECT SPREAD',
  price: '$-0.33',
  change: '-1.92',
  isNegative: true
}, {
  label: 'PORK CARCASS',
  price: '$99.04',
  change: '+0.09',
  isNegative: false
}, {
  label: 'PORK BELLY',
  price: '$154.97',
  change: '+0.16',
  isNegative: false
}, {
  label: 'PORK LOIN',
  price: '$91.93',
  change: '-1.13',
  isNegative: true
}, {
  label: 'SELECT CUTOUT',
  price: '$388.04',
  change: '+0.26',
  isNegative: false
}];
function TickerItems() {
  return <>
      {/* Powered by MeatMarket.ai */}
      <div className="flex items-center gap-1.5 px-5 py-2 flex-shrink-0" data-id="element-259">
        <span className="text-gray-500 text-[11px] tracking-wide uppercase whitespace-nowrap" data-id="element-260">
          POWERED BY
        </span>
        <a href="https://meatmarket.ai/?utm_source=meat_poultry_magazine" target="_blank" rel="noopener noreferrer" className="font-semibold text-[#002f5f] hover:underline whitespace-nowrap" data-id="element-261">
          MeatMarket.ai
        </a>
        <span className="text-gray-300 pl-3" data-id="element-262">|</span>
      </div>
      {tickerData.map((item, i) => <div key={i} className="flex items-center gap-1.5 px-5 py-2 flex-shrink-0" data-id="element-263">
          <span className="text-gray-500 text-[11px] tracking-wide uppercase whitespace-nowrap" data-id="element-264">
            {item.label}
          </span>
          <span className="font-semibold text-gray-900 whitespace-nowrap" data-id="element-265">
            {item.price}
          </span>
          <span className={`font-medium whitespace-nowrap ${item.isNegative ? 'text-red-700' : 'text-green-800'}`} data-id="element-266">
            {item.change}
          </span>
          <span className="text-gray-300 pl-3" data-id="element-267">|</span>
        </div>)}
    </>;
}
export function MarketTicker() {
  return <div className="border-t border-b border-gray-200 bg-white overflow-hidden" data-id="element-268">
      <div className="max-w-[1200px] mx-auto px-2 sm:px-4 lg:px-8" data-id="element-269">
        <div className="flex items-center text-[11px] sm:text-[13px]" data-id="element-270">
          {/* Scrolling ticker area */}
          <div className="flex-1 overflow-hidden relative" data-id="element-271">
            {/* Fade edges */}
            <div className="absolute left-0 top-0 bottom-0 w-8 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-272" />
            <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-273" />

            <div className="animate-ticker" data-id="element-274">
              <div className="flex flex-shrink-0" data-id="element-275">
                <TickerItems data-id="element-276" />
              </div>
              <div className="flex flex-shrink-0" data-id="element-277">
                <TickerItems data-id="element-278" />
              </div>
              <div className="flex flex-shrink-0" data-id="element-279">
                <TickerItems data-id="element-280" />
              </div>
            </div>
          </div>

          {/* Fixed right link */}
          <div className="hidden sm:flex flex-shrink-0 items-center py-2 pl-3 bg-white z-10 border-l border-gray-200" data-id="element-281">
            <a href="/market-iq/beef" className="flex items-center gap-1 text-[11px] text-[#002f5f] font-medium hover:underline whitespace-nowrap" data-id="element-282">
              Launch Market-IQ
              <ArrowUpRightIcon className="w-3 h-3" data-id="element-283" />
            </a>
          </div>
        </div>
      </div>
    </div>;
}